import { Link } from 'react-router-dom';
import { ButtonLink, Eyebrow } from '@mela/design-system';
import { HeroIdCard, GhostIdCard } from '../components/HeroIdCard';

export function Hero() {
  return (
    <header className="relative overflow-hidden text-center pt-24 pb-20">
      <div className="absolute inset-0 grid-bg pointer-events-none" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[radial-gradient(ellipse_at_center_top,rgba(255,107,26,0.10),transparent_60%)] pointer-events-none" />
      <div className="absolute top-[100px] left-[30%] w-[400px] h-[400px] bg-[radial-gradient(circle,rgba(109,40,217,0.06),transparent_60%)] pointer-events-none" />

      <div className="relative max-w-[1080px] mx-auto px-6 sm:px-8 flex flex-col items-center">
        <Eyebrow variant="pill" dot className="mb-8">
          <span>Built for India</span>
          <span className="w-px h-3 bg-ink-200" aria-hidden="true" />
          <span className="text-violet-600 font-medium">Now in private beta</span>
        </Eyebrow>

        <h1 className="font-display font-extrabold text-ink-900 mb-7 max-w-[18ch] text-[clamp(48px,9vw,112px)] leading-[0.92] tracking-[-0.045em]">
          One ID.
          <br />
          Every <span className="text-saffron-500">handshake</span>.
        </h1>

        <p className="text-[18px] sm:text-[22px] leading-[1.4] text-ink-600 max-w-[56ch] mb-10 font-normal">
          Mela is the <strong className="text-ink-900 font-semibold">identity layer</strong> for
          Indian B2B. Verified business profiles, AI follow-ups in your buyer’s language, and the
          only event tool built for how India actually does business.{' '}
          <strong className="text-ink-900 font-semibold">Free forever.</strong>
        </p>

        <div className="flex gap-3 flex-wrap justify-center mb-3">
          <ButtonLink href="/login" variant="primary" size="xl">
            Claim your Mela ID — free
          </ButtonLink>
          <ButtonLink href="#exhibitors" variant="outline" size="xl">
            How it works
          </ButtonLink>
        </div>
        <p className="text-[13px] text-ink-500 mb-10">
          Not ready?{' '}
          <Link to="/#waitlist" className="text-saffron-600 hover:text-saffron-700 font-medium underline decoration-dotted">
            Join the waitlist instead
          </Link>
        </p>

        <TrustStrip />
        <HeroVisual />
      </div>
    </header>
  );
}

function TrustStrip() {
  return (
    <div className="flex gap-4 sm:gap-7 items-center flex-wrap justify-center pt-8">
      <TrustItem icon={<StarIcon />} text="DPDP-compliant from Day 1" />
      <TrustItem icon={<ServerIcon />} text="Servers in Mumbai" />
      <TrustItem icon={<SquareIcon />} text="90-second signup, no credit card" />
    </div>
  );
}

function TrustItem({ icon, text }: { icon: React.ReactNode; text: string }) {
  return (
    <div className="flex items-center gap-2 font-mono text-[11px] text-ink-500 tracking-wide">
      <span className="text-violet-600 w-3.5 h-3.5 inline-flex">{icon}</span>
      <span>{text}</span>
    </div>
  );
}

function HeroVisual() {
  return (
    <div className="mt-16 relative w-full max-w-[880px] flex justify-center items-center [perspective:1000px] min-h-[280px]">
      <GhostIdCard className="left-[calc(50%-280px)] top-[30px] -rotate-6 opacity-70" />
      <GhostIdCard className="right-[calc(50%-280px)] top-[20px] rotate-[5deg] opacity-70" />
      <HeroIdCard />
    </div>
  );
}

function StarIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" className="w-full h-full">
      <path d="M8 0L9.8 5.2L15 5.2L10.6 8.8L12.4 14L8 10.4L3.6 14L5.4 8.8L1 5.2L6.2 5.2Z" />
    </svg>
  );
}
function ServerIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" className="w-full h-full">
      <circle cx="8" cy="8" r="6" />
    </svg>
  );
}
function SquareIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor" className="w-full h-full">
      <rect x="2" y="2" width="12" height="12" rx="2" />
    </svg>
  );
}
